import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { DropdownMenuTypePropType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';

import { useAvailableInsuranceOptions } from '../../services/insurance-service';
import { useFulfillmentPlannerContext } from '../context';

import InsuranceOption from './index';

const InsuranceOptionContainer = ({ id, dropdownMenuType, className, isPartOfInsurancePromoExperiment = false }) => {
  const { insuranceProvider, onInsuranceProviderChange, serviceIdAndSellerLabelProviderId } = useFulfillmentPlannerContext();
  const selectedInsuranceOptionName = insuranceProvider.name;
  const insuranceOptions = useAvailableInsuranceOptions(serviceIdAndSellerLabelProviderId?.sellerLabelProviderId);

  return (
    <InsuranceOption
      className={className}
      dropdownMenuType={dropdownMenuType}
      id={id}
      insuranceOptions={insuranceOptions}
      isPartOfInsurancePromoExperiment={isPartOfInsurancePromoExperiment}
      onChange={onInsuranceProviderChange}
      selectedInsuranceOptionName={selectedInsuranceOptionName}
    />
  );
};

InsuranceOptionContainer.propTypes = {
  id: PropTypes.string,
  dropdownMenuType: DropdownMenuTypePropType,
  className: PropTypes.string,
  isPartOfInsurancePromoExperiment: PropTypes.bool,
};

export default memo(InsuranceOptionContainer);
